const routeNames = {
  Account: 'account',
  Agreements: 'agreements',
  Error: 'error',
  Folder: 'reportView',
  ForwardDocument: 'forwardDocument',
  Inspection: 'inspection',
  Inspections: 'myInspections',
  Inspectors: 'myInspectors',
  Invoice: 'invoice',
  Offers: 'offers',
  Payment: 'payment',
  RateInspector: 'rateInspector',
  Receipt: 'receipt',
  UsedCardboardBoxes: 'usedCardboardBoxes',
  Welcome: 'welcome',
  SpareFoot: 'spareFoot',
  AllConnect: 'allConnect',
  UnPakt: 'unpakt',
  Bellhop: 'bellhop',
};

export default routeNames;
